/**
 * Sensitivity matrices that show valuation results for changes in rent and discount rate.
 * Put scenario inputs, matrix rows and result values here. Use the existing money schemas for monetary fields.
 */
import { z } from 'zod';
import { MonetaryValueSchema, SquareMetreMoneyPerAreaValueSchema } from './money';
export const ValuationSensitivityMatrixValuesSchema = z.object({
    asset_value: MonetaryValueSchema.optional(),
    asset_value_per_sqm: SquareMetreMoneyPerAreaValueSchema.optional(),
    delta_to_base: z.number().optional(),
    yield_rate: z.number().optional(),
    multiplier: z.number().optional(),
});
const ValuationSensitivityMatrixDiscountRateSchema = z.object({
    base_discount_rate: ValuationSensitivityMatrixValuesSchema.optional(),
    increased_discount_rate: ValuationSensitivityMatrixValuesSchema.optional(),
    decreased_discount_rate: ValuationSensitivityMatrixValuesSchema.optional(),
});
const ValuationSensitivityMatrixResultsSchema = z.object({
    base_rent: ValuationSensitivityMatrixDiscountRateSchema.optional(),
    increased_rent: ValuationSensitivityMatrixDiscountRateSchema.optional(),
    decreased_rent: ValuationSensitivityMatrixDiscountRateSchema.optional(),
});
export const ValuationSensitivityMatrixSchema = z.object({
    rent_change: z.number(),
    discount_rate_change: z.number(),
    results: ValuationSensitivityMatrixResultsSchema,
});
